import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const ErrorIcon: FC<ReactNode> = () => (
  <div className='icon-container'>
    <img
      srcSet={
        'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/da54a74b3efcee41e53269a6ee58c721_Illustration_Functional_Black_House.png, ' +
        'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/bf9feecc89e47833ccd3e5e3684b60fa_Illustration_Functional_Black_House@2x.png 2x, ' +
        'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/68984851a6c086c51744a0a28c03e104_Illustration_Functional_Black_House@3x.png 3x'
      }
      src={
        'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/da54a74b3efcee41e53269a6ee58c721_Illustration_Functional_Black_House.png'
      }
      width={100}
      height={82}
      alt={''}
    />
  </div>
)
